<template>
  <div class="upload">
    <button type="text" @click="open" @mouseover="addsupplyimg=true" @mouseout="addsupplyimg=false">
      <img v-show="addsupplyimg" class="addSupply" src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/addSupply_1.png" alt=""/>
      <img v-show="!addsupplyimg" class="addSupply" src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/addSupply.png" alt=""/>
      发布信息
    </button>
    <el-dialog
    title="发布信息"
    :visible.sync="dialogFormVisible"
    top="3vh"
    width="650px"
    custom-class="positioning"
    center>
      <h2 class="biaoti"><span style="color:red">*</span>类别</h2>
      <div class="dalei">
        <el-button :class="{activ:status=='gong'}" @click="$store.dispatch('release','gong')">供应信息</el-button>
        <el-button :class="{activ:status=='xu'}" @click="$store.dispatch('release','xu')">采购信息</el-button>
      </div>
      <h2><span style="color:red">*</span>分类</h2>
      <div>
        <el-button :class="{activ:form.sort==1}" @click="form.sort=1">石油石化</el-button>
        <el-button :class="{activ:form.sort==2}" @click="form.sort=2">页岩气</el-button>
        <el-button :class="{activ:form.sort==3}" @click="form.sort=3">海洋石油天然气</el-button>
        <el-button :class="{activ:form.sort==4}" @click="form.sort=4">管道与储运</el-button>
        <el-button :class="{activ:form.sort==5}" @click="form.sort=5">海工装备</el-button>
        <el-button :class="{activ:form.sort==6}" @click="form.sort=6">安全防护</el-button>
        <el-button :class="{activ:form.sort==7}" @click="form.sort=7">天然气</el-button>
        <el-button :class="{activ:form.sort==8}" @click="form.sort=8">防爆仪器仪表</el-button>
        <el-button :class="{activ:form.sort==9}" @click="form.sort=9">智能油田</el-button>
        <el-button :class="{activ:form.sort==10}" @click="form.sort=10">油田土壤修复</el-button>
        <el-button :class="{activ:form.sort==11}" @click="form.sort=11">其他</el-button>
      </div>
      <h2><span style="color:red">*</span>内容描述</h2>
      <div>
        <el-input
          type="textarea"
          :show-word-limit="true"
          maxlength="500"
          resize="none"
          placeholder="请输入内容"
          v-model="form.content">
        </el-input>
      </div>
      <!-- 上传图片 -->
      <div class="uploadModule">
        <!-- accept=".jpg, .png" -->
         <el-upload
          ref="upload"
          action="/gongxujson/upload"
          list-type="picture-card"
          accept="image/*"
          :limit="imgLimit"
          :file-list="form.imgurl"
          :multiple="isMultiple"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
          :on-error="imgUploadError"
          >
          <i class="el-icon-plus"></i>
          <div slot="file" slot-scope="{file}">
            <img
              class="el-upload-list__item-thumbnail"
              :src="file.msg"/>
            <span class="el-upload-list__item-actions">
              <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)" >
                <i class="el-icon-zoom-in"></i>
              </span>
              <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)" >
                <i class="el-icon-delete"></i>
              </span>
            </span>
          </div>
        </el-upload>
        <!-- 预览 -->
        <el-dialog :visible.sync="dialogVisible" append-to-body center>
          <img width="100%" :src="dialogImageUrl" alt=""/>
        </el-dialog>
      </div>
      <p class="remind"><i class="iconfont icon-gantan"></i> 多次连续发布重复信息可能将被封号（上传图片大小不超过150K）</p>
      <span style="color:red">*</span><el-checkbox v-model="form.checked"></el-checkbox> <span>我已阅读并同意<a class="ahover" @click.stop="()=>{webHerf('/gongxujson/xieyi')}">《平台用户服务协议》</a></span>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reset">取 消</el-button>
        <el-button type="primary" @click="addList">发 布</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { reqRelease, reqDelImage } from "../../../api";
export default {
  data () {
    return {
      imgLimit:3,//上传最大个数
      dialogVisible:false,
      productImgs:[],
      isMultiple: true,
      dialogImageUrl:"",
      form: {
          status:0,
          sort: '',
          content:"",//内容
          address:"",//地址
          imgurl:[],//图片列表
          checked: false,//勾选同意状态
        },
      dialogFormVisible:false,//弹窗切换
      disabled:false,
      classList:[
        {
          id:1,
          name:"石油石化",
        },
        {
          id:2,
          name:"页岩气",
        },
        {
          id:3,
          name:"海洋石油天然气",
        },
        {
          id:4,
          name:"管道与存储",
        },
        {
          id:5,
          name:"海工装备",
        },
        {
          id:6,
          name:"安全防护",
        },
        {
          id:7,
          name:"天然气",
        },
        {
          id:8,
          name:"防爆仪器仪表",
        },
        {
          id:9,
          name:"智能油田",
        },
        {
          id:10,
          name:"油田土壤修复",
        },
        {
          id:11,
          name:"其他",
        }
      ],
      addsupplyimg:false,//添加图标显示隐藏
      
    }
  },
  mounted(){
    this.form.status = this.status
  },
  methods:{
    async handleRemove(file) {//移除图片
      const response = await reqDelImage(file.msg)
      if (response.code==1) {
        this.success(this,'删除成功！')
        this.delTtemImg(file.msg)
        return true
      }else{
        this.err(this,'删除失败！');
        return false
      }
    },

    handlePictureCardPreview(file) {//预览图片时调用
      this.dialogImageUrl = file.msg;
      this.dialogVisible = true;
    },

    beforeAvatarUpload(file) {//文件上传之前调用做一些拦截限制
      const isLt150K = file.size / 1024 <= 1024;
      if (!isLt150K) {
        this.err(this,'上传图片大小不能超过 1M!');
      }
      return isLt150K;
    },

    handleAvatarSuccess(response, file) {//图片上传成功
      response.name=file.name
      this.form.imgurl.push({name:file.name,msg:response.msg})
    },

    imgUploadError(){//图片上传失败调用
      this.err(this,'上传图片失败!');
    },
    
    async addList(){// 添加
      if(this.form.status==Number&&this.form.sort!==""&&this.form.content.length>0&&this.form.checked){
        let date={...this.form}
        date.status=this.status=="gong"?0:1
        let arr = []
        date.imgurl.forEach(item =>arr.push(item.msg));
        date.imgurl=arr
        date.imgurl = JSON.stringify(date.imgurl)
        const response = await reqRelease(date)
        console.log(response);
        this.dialogFormVisible = false
        this.form.status=Number
        this.form.sort=""
        this.form.content=""
        this.form.address=""
        this.form.imgurl=[]
        this.$refs.upload.clearFiles();
        this.form.checked=false
      }
    },

    reset(){
      this.dialogFormVisible = false
      this.delImg()
      this.form.status=Number
      this.form.sort=""
      this.form.content=""
      this.form.address=""
      this.$refs.upload.clearFiles();
      this.form.checked=false
    },

    open(){
      if (!(this.isLogin)) {
        this.isPath1(this)
        this.$store.dispatch("dialog",true)
      }else{
        this.form.status=Number
        this.form.sort=""
        this.form.content=""
        this.form.address=""
        this.form.imgurl=[]
        if(this.$refs.upload){
        this.$refs.upload.clearFiles();
        }
        this.form.checked=false
        this.dialogFormVisible = true
      }
    },

    delTtemImg(url){
      if (this.form.imgurl.length) {
        let index = this.form.imgurl.findIndex((item)=>item.url==url)
        this.form.imgurl.splice(index,1)
      }
    },
    
    delImg(){//批量删除图片
      if (this.form.imgurl.length) {
        this.form.imgurl.forEach(async(item)=> {
          await reqDelImage(item.url)
        });
      }
    }
  },
  computed:{
    ...mapState({
      isLogin:state=>state.user.isLogin,
      status:state=>state.supply.category
    })
  }

}
</script>

<style scoped>
  .upload>button{
    width: 100%;
    height: 90px;
    outline: none;
    border: none;
    font-size: 20px;
    font-weight: 600;
    color: #008baf;
    margin-bottom: 2px;
    background-color: white;
    vertical-align: middle;
    box-shadow: 0px -1px 10px #aaa;
    cursor: pointer;
    transition: all .5s;
  }
  .upload>button:hover{
    color: white;
    background-color: #008baf;
  }
  .addSupply{
    width: 32px;
    vertical-align: middle;
  }
  .dialog-footer{
    text-align: center;
    
  }
  .dialog-footer>>>.el-button{
    width: 150px;
    height: 40px;
    border-radius: 4px;
    transition: all .5s;
  }
  
  .jia{
    font-size: 36px;
    vertical-align: middle;
    margin-right: 6px;
  }
  .upload .el-dialog__wrapper{
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  }
  .upload>>>.el-dialog, .upload>>>.el-pager li{
    background-color: #fff;
    padding: 28px 38px;
    width: 660px;
  }
  .upload>>>.el-dialog__header{
    border-bottom: 1px solid #aaa;
    text-align: center;
    padding-top: 10px;
    padding-bottom: 20px;
  }
  .upload >>>.el-dialog__title{
    font-size: 22px;
    font-weight: 600;
  }
  .upload>>>.el-dialog__headerbtn .el-dialog__close{
    display: none;
  }
  .upload h2{
    font-size: 16px;
    font-weight: 600;
    color: black;
    padding-bottom: 6px;
  }
  .upload .biaoti{
    display: inline-block;
  }
  .dalei{
    display: inline-block;
    margin-left: 20px;
  }
  .upload >>>.el-dialog__body{
    padding:14px 20px;
  }
  .upload >>>.el-dialog__body .el-button{
    color: #818181;
    background-color: white;
    border-color: #818181;
    outline: none;
    width: auto;
    height: auto;
    padding: 5px 10px;
    font-size: 12px;
    border-radius: 5px;
    margin: auto 10px 10px 0;
  }
  
  .upload >>>.el-textarea__inner{
    height: 110px;
  }
  .uploadModule{
    position: relative;
    padding: 10px;
  }
  .caveat{
    margin-top: 6px;
    font-size: 12px;
    color: red;
  }
  .remind{
    color: red;
  }
  .caveat i,
  .remind i{
    vertical-align: middle;
    margin-right: 4px;
  }
  .upload >>> .el-upload--picture-card,
  .upload >>>.el-upload-list--picture-card .el-upload-list__item{
    width: 80px;
    height: 80px;
  }
  .upload >>> .el-upload--picture-card i{
    line-height: 80px;
    vertical-align: top;
  }
  .ahover{
    cursor: pointer;
    color: #008baf;
  }
  .ahover:hover{
    color: #f08300;
  }
  
</style>